import { graphql, useStaticQuery } from "gatsby"

export const useTeamOrder = (locale) => {
  const { allCosmicjsTeamOrder } = useStaticQuery(graphql`
    query {
      allCosmicjsTeamOrder {
        nodes {
          slug
          id
          title
          locale
          metadata {
            team_members_order {
              slug
              id
              title
              locale
              metadata {
                team_job_title
                team_quote
                team_image {
                  imgix_url
                }
              }
            }
          }
        }
      }
    }
  `)
  
  let localizedItems = allCosmicjsTeamOrder.nodes.filter((item) => item.locale === locale)
  if (!localizedItems.length) {
    localizedItems = allCosmicjsTeamOrder.nodes.filter((item) => item.locale === "en-US")
  }
  const order = localizedItems[0]
  return order?.metadata?.team_members_order || []
}
